var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { useNavigate } from "react-router-dom";
import { useDelete, useNotify, useRedirect, useUpdate } from "react-admin";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import InventoryIcon from "@mui/icons-material/Inventory";
import { Divider, ListItemIcon, MenuItem, MenuList, Popover } from "@mui/material";
import { Dialog, adminTheme } from "@sequentech/ui-essentials";
import { getNavLinkCreate, mapAddResource, mapImportResource } from "./TreeMenu";
import { useActionPermissions, useTreeMenuData } from "../use-tree-menu-hook";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import { divContainer } from "@/components/styles/Menu";
import { useApolloClient, useMutation } from "@apollo/client";
import { DELETE_ELECTION_EVENT } from "@/queries/DeleteElectionEvent";
import { IPermissions } from "@/types/keycloak";
import { useElectionEventTallyStore } from "@/providers/ElectionEventTallyProvider";
import { useCreateElectionEventStore } from "@/providers/CreateElectionEventContextProvider";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import { ETasksExecution } from "@/types/tasksExecution";
import { isBallotBoxSealedError, sealText } from "@/services/ballotBoxSealErrors";
import { GET_BALLOT_BOX_SEALS, GET_EVENT_BALLOT_BOX_SEALS } from "@/queries/GetBallotBoxSeals";
import { useSealReadRole } from "@/hooks/useSealReadRole";
import { isSealAtClose } from "@/services/ballotBoxSealPolicy";
import { getMenuActionConfirmMessage } from "./menuActionConfirmMessage";
/** What the pre-check of a delete found about ballot box seals (VOTE-FREEZE). */
var ESealCheck;
(function (ESealCheck) {
    /** No seals, or not an election or event. */
    ESealCheck["NONE"] = "none";
    /** It has seals: it can't be deleted. */
    ESealCheck["SEALED"] = "sealed";
    /** The seals could not be read. */
    ESealCheck["UNKNOWN"] = "unknown";
})(ESealCheck || (ESealCheck = {}));
var mapRemoveResource = {
    sequent_backend_election_event: "sideMenu.menuActions.remove.electionEvent",
    sequent_backend_election: "sideMenu.menuActions.remove.election",
    sequent_backend_contest: "sideMenu.menuActions.remove.contest",
    sequent_backend_candidate: "sideMenu.menuActions.remove.candidate",
};
var Action;
(function (Action) {
    Action[Action["Add"] = 0] = "Add";
    Action[Action["Import"] = 1] = "Import";
    Action[Action["Remove"] = 2] = "Remove";
    Action[Action["Archive"] = 3] = "Archive";
    Action[Action["Unarchive"] = 4] = "Unarchive";
})(Action || (Action = {}));
var StyledIconContainer = styled("p")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), divContainer);
var StyledActionsButton = styled("button")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    padding: 0;\n    border: 0;\n    background: none;\n    color: inherit;\n    cursor: pointer;\n"], ["\n    ", "\n    padding: 0;\n    border: 0;\n    background: none;\n    color: inherit;\n    cursor: pointer;\n"])), divContainer);
var StyledAddCircleIcon = styled(AddCircleIcon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), adminTheme.palette.brandColor);
export default function MenuAction(_a) {
    var _this = this;
    var isArchivedTab = _a.isArchivedTab, resourceId = _a.resourceId, resourceName = _a.resourceName, resourceType = _a.resourceType, parentData = _a.parentData, menuItemRef = _a.menuItemRef, setAnchorEl = _a.setAnchorEl, anchorEl = _a.anchorEl, reloadTree = _a.reloadTree;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var navigate = useNavigate();
    var redirect = useRedirect();
    var deleteOne = useDelete()[0];
    var update = useUpdate()[0];
    var delete_election_event = useMutation(DELETE_ELECTION_EVENT, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.ELECTION_EVENT_DELETE,
            },
        },
    })[0];
    var notify = useNotify();
    var _c = useTreeMenuData(isArchivedTab), treeData = _c.data, refetch = _c.refetch;
    var _d = React.useState(false), openArchiveModal = _d[0], setOpenArchiveModal = _d[1];
    var _e = React.useState(false), openDeleteModal = _e[0], setOpenDeleteModal = _e[1];
    // What the pre-check found about the ballot box seals of the election or
    // event to remove (VOTE-FREEZE): sealed ones can't be deleted.
    var _f = React.useState(ESealCheck.NONE), sealCheck = _f[0], setSealCheck = _f[1];
    var apollo = useApolloClient();
    var sealRole = useSealReadRole();
    /**
     * Whether the election or event has ballot box seals. The database (or
     * the delete task) refuses to delete it then, and outside Hasura's dev
     * mode its error doesn't say why, so the dialog says it before. The seals
     * are read with a role the user has; when none can read them, the dialog
     * says they could not be checked.
     */
    var checkSeals = function (payload) { return __awaiter(_this, void 0, void 0, function () {
        var isElection, eventId, event, context, data, _a, _b;
        var _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    isElection = payload.type === "sequent_backend_election";
                    if (!isElection && payload.type !== "sequent_backend_election_event") {
                        return [2 /*return*/, ESealCheck.NONE];
                    }
                    eventId = String(isElection ? parentData.id : payload.id);
                    event = (_c = treeData === null || treeData === void 0 ? void 0 : treeData.sequent_backend_election_event) === null || _c === void 0 ? void 0 : _c.find(function (item) { return String(item.id) === eventId; });
                    if (event && !isSealAtClose(event.presentation))
                        return [2 /*return*/, ESealCheck.NONE];
                    if (!sealRole)
                        return [2 /*return*/, ESealCheck.UNKNOWN];
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 6, , 7]);
                    context = { headers: { "x-hasura-role": sealRole } };
                    if (!isElection) return [3 /*break*/, 3];
                    return [4 /*yield*/, apollo.query({
                            query: GET_BALLOT_BOX_SEALS,
                            variables: {
                                electionEventId: parentData.id,
                                electionIds: [String(payload.id)],
                            },
                            fetchPolicy: "network-only",
                            context: context,
                        })];
                case 2:
                    _a = _e.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, apollo.query({
                        query: GET_EVENT_BALLOT_BOX_SEALS,
                        variables: { electionEventId: String(payload.id) },
                        fetchPolicy: "network-only",
                        context: context,
                    })];
                case 4:
                    _a = _e.sent();
                    _e.label = 5;
                case 5:
                    data = (_a).data;
                    return [2 /*return*/, ((_d = data === null || data === void 0 ? void 0 : data.sequent_backend_ballot_box_seal) === null || _d === void 0 ? void 0 : _d.length)
                            ? ESealCheck.SEALED
                            : ESealCheck.NONE];
                case 6:
                    _b = _e.sent();
                    return [2 /*return*/, ESealCheck.UNKNOWN];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var _g = React.useState(null), selectedActionModal = _g[0], setSelectedActionModal = _g[1];
    var _h = useWidgetStore(), addWidget = _h[0], setWidgetTaskId = _h[1], updateWidgetFail = _h[2];
    var isItemElectionEventType = resourceType === "sequent_backend_election_event";
    var _j = useElectionEventTallyStore(), setElectionEventIdFlag = _j.setElectionEventIdFlag, setElectionIdFlag = _j.setElectionIdFlag, setContestIdFlag = _j.setContestIdFlag, setCandidateIdFlag = _j.setCandidateIdFlag;
    function handleOpenItemActions() {
        setAnchorEl(menuItemRef.current);
    }
    function handleAction(action, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // close the popover
                        setAnchorEl(null);
                        if (!(action === Action.Add)) return [3 /*break*/, 1];
                        navigate(getNavLinkCreate(parentData, payload.type));
                        return [3 /*break*/, 4];
                    case 1:
                        if (!(payload.type === "sequent_backend_election_event" &&
                            (action === Action.Archive || action === Action.Unarchive))) return [3 /*break*/, 2];
                        setSelectedActionModal({ action: action, payload: payload });
                        setOpenArchiveModal(true);
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(action === Action.Remove)) return [3 /*break*/, 4];
                        _a = setSealCheck;
                        return [4 /*yield*/, checkSeals(payload)];
                    case 3:
                        _a.apply(void 0, [_b.sent()]);
                        setSelectedActionModal({ action: action, payload: payload });
                        setOpenDeleteModal(true);
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function handleCloseActionMenu() {
        setAnchorEl(null);
    }
    function confirmArchiveAction() {
        return __awaiter(this, void 0, void 0, function () {
            var action, payload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedActionModal) {
                            return [2 /*return*/];
                        }
                        action = selectedActionModal.action, payload = selectedActionModal.payload;
                        if (!(action === Action.Archive)) return [3 /*break*/, 1];
                        update(payload.type, {
                            id: payload.id,
                            data: { is_archived: true },
                            previousData: { is_archived: false },
                        }, {
                            onSuccess: function () {
                                refetch();
                                notify(t("sideMenu.menuActions.messages.notification.success.archive"), {
                                    type: "success",
                                });
                            },
                            onError: function () {
                                notify(t("sideMenu.menuActions.messages.notification.error.archive"), {
                                    type: "error",
                                });
                            },
                        });
                        return [3 /*break*/, 3];
                    case 1:
                        if (!(action === Action.Unarchive)) return [3 /*break*/, 3];
                        return [4 /*yield*/, update(payload.type, {
                                id: payload.id,
                                data: { is_archived: false },
                                previousData: { is_archived: true },
                            }, {
                                onSuccess: function () {
                                    refetch();
                                    notify(t("sideMenu.menuActions.messages.notification.success.unarchive"), {
                                        type: "success",
                                    });
                                },
                                onError: function () {
                                    notify(t("sideMenu.menuActions.messages.notification.error.unarchive"), {
                                        type: "error",
                                    });
                                },
                            })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    var deleteElectionEventAction = function (payload) { return __awaiter(_this, void 0, void 0, function () {
        var currWidget, _a, data, errors, errorMessage, failedTask, taskId, error_1;
        var _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    currWidget = addWidget(ETasksExecution.DELETE_ELECTION_EVENT, undefined);
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, delete_election_event({
                            variables: {
                                electionEventId: payload.id,
                            },
                        })];
                case 2:
                    _a = _g.sent(), data = _a.data, errors = _a.errors;
                    errorMessage = (_b = data === null || data === void 0 ? void 0 : data.delete_election_event) === null || _b === void 0 ? void 0 : _b.error_msg;
                    if (errorMessage || errors) {
                        // Say why (e.g. the event has sealed ballot boxes), and let the
                        // widget show the task's log when there is a task.
                        if (errorMessage)
                            notify(sealText(t, errorMessage), { type: "error" });
                        failedTask = (_d = (_c = data === null || data === void 0 ? void 0 : data.delete_election_event) === null || _c === void 0 ? void 0 : _c.task_execution) === null || _d === void 0 ? void 0 : _d.id;
                        if (failedTask) {
                            setWidgetTaskId(currWidget.identifier, failedTask);
                        }
                        else {
                            updateWidgetFail(currWidget.identifier);
                        }
                        return [2 /*return*/];
                    }
                    taskId = (_f = (_e = data === null || data === void 0 ? void 0 : data.delete_election_event) === null || _e === void 0 ? void 0 : _e.task_execution) === null || _f === void 0 ? void 0 : _f.id;
                    setWidgetTaskId(currWidget.identifier, taskId, function () {
                        setSelectedActionModal(null);
                        setElectionEventIdFlag(null);
                        setElectionIdFlag(null);
                        setContestIdFlag(null);
                        reloadTree();
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _g.sent();
                    updateWidgetFail(currWidget.identifier);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    function confirmDeleteAction() {
        return __awaiter(this, void 0, void 0, function () {
            var payload;
            var _a;
            return __generator(this, function (_b) {
                payload = (_a = selectedActionModal === null || selectedActionModal === void 0 ? void 0 : selectedActionModal.payload) !== null && _a !== void 0 ? _a : null;
                if (!payload) {
                    return [2 /*return*/];
                }
                if (payload.type === "sequent_backend_election_event") {
                    deleteElectionEventAction(payload);
                }
                else {
                    deleteOne(payload.type, { id: payload.id }, {
                        onSuccess: function () {
                            reloadTree();
                            refetch();
                            notify(t("sideMenu.menuActions.messages.notification.success.delete"), {
                                type: "success",
                            });
                            if ((parentData === null || parentData === void 0 ? void 0 : parentData.__typename) === "sequent_backend_election_event") {
                                setElectionEventIdFlag("");
                                setElectionIdFlag("");
                                navigate("/sequent_backend_election_event/" + parentData.id);
                            }
                            if ((parentData === null || parentData === void 0 ? void 0 : parentData.__typename) === "sequent_backend_election") {
                                setElectionIdFlag("");
                                setContestIdFlag("");
                                navigate("/sequent_backend_election/" + parentData.id);
                            }
                            if ((parentData === null || parentData === void 0 ? void 0 : parentData.__typename) === "sequent_backend_contest") {
                                setElectionIdFlag("");
                                setContestIdFlag("");
                                navigate("/sequent_backend_contest/" + parentData.id);
                            }
                        },
                        onError: function (error) {
                            setOpenDeleteModal(false);
                            // A sealed election can't be deleted (VOTE-FREEZE): say why.
                            notify(t(isBallotBoxSealedError(error)
                                ? "sideMenu.menuActions.messages.notification.error.deleteSealedElection"
                                : sealCheck === ESealCheck.UNKNOWN
                                    ? "sideMenu.menuActions.messages.notification.error.deleteMaybeSealed"
                                    : "sideMenu.menuActions.messages.notification.error.delete"), { type: "error" });
                        },
                        onSettled: function () {
                            setSelectedActionModal(null);
                        },
                    });
                }
                return [2 /*return*/];
            });
        });
    }
    var openActionMenu = Boolean(anchorEl);
    var idActionMenu = openActionMenu ? "action-menu" : undefined;
    /**
     * Permissions
     */
    var _k = useActionPermissions(), canCreateElectionEvent = _k.canCreateElectionEvent, canDeleteElectionEvent = _k.canDeleteElectionEvent, canArchiveElectionEvent = _k.canArchiveElectionEvent, canCreateContest = _k.canCreateContest, canDeleteContest = _k.canDeleteContest, canCreateCandidate = _k.canCreateCandidate, canDeleteCandidate = _k.canDeleteCandidate, canCreateElection = _k.canCreateElection, canDeleteElection = _k.canDeleteElection;
    var canShowCreate = (resourceType === "sequent_backend_election_event" && canCreateElectionEvent) ||
        (resourceType === "sequent_backend_election" && canCreateElection) ||
        (resourceType === "sequent_backend_contest" && canCreateContest && canCreateElection) ||
        (resourceType === "sequent_backend_candidate" &&
            canCreateCandidate &&
            canCreateElection &&
            canCreateContest);
    var canShowDelete = (resourceType === "sequent_backend_election_event" && canDeleteElectionEvent) ||
        (resourceType === "sequent_backend_election" && canDeleteElection) ||
        (resourceType === "sequent_backend_contest" && canDeleteContest && canDeleteElection) ||
        (resourceType === "sequent_backend_candidate" &&
            canDeleteCandidate &&
            canDeleteElection &&
            canDeleteContest);
    /**
     * ======
     */
    /**
     * Create and import ee from drawer
     */
    var _l = useCreateElectionEventStore(), openCreateDrawer = _l.openCreateDrawer, openImportDrawer = _l.openImportDrawer;
    var handleOpenCreateElectionEventForm = function (e) {
        setAnchorEl(null);
        openCreateDrawer === null || openCreateDrawer === void 0 ? void 0 : openCreateDrawer();
    };
    var handleOpenImportElectionEventForm = function (e) {
        setAnchorEl(null);
        openImportDrawer === null || openImportDrawer === void 0 ? void 0 : openImportDrawer();
    };
    /**
     * ======
     */
    return (_jsxs(_Fragment, { children: [_jsx(StyledIconContainer, { children: ((!isArchivedTab && (canShowCreate || canShowDelete || canArchiveElectionEvent)) ||
                    (isArchivedTab && (canArchiveElectionEvent || canShowDelete))) && (_jsx(StyledActionsButton, { type: "button", "aria-label": "".concat(t("common.label.actions"), ": ").concat(resourceName), "aria-haspopup": "menu", onClick: handleOpenItemActions, children: _jsx(MoreHorizIcon, { id: "MoreHorizIcon" }) })) }), _jsx(Popover, { id: idActionMenu, open: openActionMenu, anchorEl: anchorEl, onClose: handleCloseActionMenu, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right",
                }, children: _jsxs(MenuList, { dense: true, children: [!isArchivedTab && canShowCreate && (_jsxs(MenuItem, { dir: i18n.dir(i18n.language), className: "menu-action-add-".concat(resourceType), onClick: function (e) {
                                if (resourceType === "sequent_backend_election_event") {
                                    handleOpenCreateElectionEventForm(e);
                                }
                                else {
                                    handleAction(Action.Add, {
                                        id: resourceId,
                                        name: resourceName,
                                        type: resourceType,
                                    });
                                }
                            }, children: [_jsx(ListItemIcon, { children: _jsx(StyledAddCircleIcon, {}) }), t(mapAddResource[resourceType])] }, Action.Add)), isItemElectionEventType &&
                            !isArchivedTab &&
                            canShowCreate &&
                            canShowDelete && _jsx(Divider, {}, "divider0"), !isArchivedTab &&
                            canShowCreate &&
                            resourceType === "sequent_backend_election_event" ? (_jsxs(MenuItem, { dir: i18n.dir(i18n.language), className: "menu-action-add-".concat(resourceType), onClick: handleOpenImportElectionEventForm, children: [_jsx(ListItemIcon, { children: _jsx(StyledAddCircleIcon, {}) }), t(mapImportResource[resourceType])] }, Action.Import)) : null, isItemElectionEventType &&
                            !isArchivedTab &&
                            canShowCreate &&
                            canShowDelete && _jsx(Divider, {}, "divider1"), isItemElectionEventType && canArchiveElectionEvent && (_jsxs(MenuItem, { dir: i18n.dir(i18n.language), className: "menu-action-archive-".concat(resourceType), onClick: function () {
                                return handleAction(isArchivedTab ? Action.Unarchive : Action.Archive, {
                                    id: resourceId,
                                    name: resourceName,
                                    type: resourceType,
                                });
                            }, children: [_jsx(ListItemIcon, { children: _jsx(InventoryIcon, { color: "error" }) }), isArchivedTab
                                    ? t("sideMenu.menuActions.unarchive.electionEvent")
                                    : t("sideMenu.menuActions.archive.electionEvent")] }, Action.Archive)), canArchiveElectionEvent && canShowCreate && canShowDelete && (_jsx(Divider, {}, "divider2")), canShowDelete && (_jsxs(MenuItem, { dir: i18n.dir(i18n.language), className: "menu-action-delete-".concat(resourceType), onClick: function () {
                                return handleAction(Action.Remove, {
                                    id: resourceId,
                                    name: resourceName,
                                    type: resourceType,
                                });
                            }, children: [_jsx(ListItemIcon, { children: _jsx(DeleteIcon, { color: "error" }) }), t(mapRemoveResource[resourceType])] }, Action.Remove))] }) }), _jsx(Dialog, { variant: "warning", open: openArchiveModal, ok: (selectedActionModal === null || selectedActionModal === void 0 ? void 0 : selectedActionModal.action) === Action.Archive
                    ? t("common.label.archive")
                    : t("common.label.unarchive"), cancel: String(t("common.label.cancel")), title: String(t("common.label.warning")), handleClose: function (result) {
                    if (result) {
                        confirmArchiveAction();
                    }
                    setOpenArchiveModal(false);
                }, children: getMenuActionConfirmMessage(t, (selectedActionModal === null || selectedActionModal === void 0 ? void 0 : selectedActionModal.action) === Action.Archive ? "archive" : "unarchive", selectedActionModal === null || selectedActionModal === void 0 ? void 0 : selectedActionModal.payload.name) }), _jsx(Dialog, { variant: "warning", open: openDeleteModal, ok: sealCheck === ESealCheck.SEALED ? undefined : String(t("common.label.delete")), cancel: String(t("common.label.cancel")), title: String(t("common.label.warning")), handleClose: function (result) {
                    if (result && sealCheck !== ESealCheck.SEALED) {
                        confirmDeleteAction();
                    }
                    setOpenDeleteModal(false);
                }, children: sealCheck === ESealCheck.SEALED
                    ? t((selectedActionModal === null || selectedActionModal === void 0 ? void 0 : selectedActionModal.payload.type) === "sequent_backend_election_event"
                        ? "sideMenu.menuActions.messages.notification.error.deleteSealedEvent"
                        : "sideMenu.menuActions.messages.notification.error.deleteSealedElection")
                    : sealCheck === ESealCheck.UNKNOWN
                        ? "".concat(getMenuActionConfirmMessage(t, "delete", selectedActionModal === null || selectedActionModal === void 0 ? void 0 : selectedActionModal.payload.name), " ").concat(t("sideMenu.menuActions.messages.confirm.sealsUnknown"))
                        : getMenuActionConfirmMessage(t, "delete", selectedActionModal === null || selectedActionModal === void 0 ? void 0 : selectedActionModal.payload.name) })] }));
}
var templateObject_1, templateObject_2, templateObject_3;
